import React, { Component } from 'react';
import { Parallax } from "react-parallax";

export class PolicyPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <section id="terms-of-services">
                <Parallax blur={4} bgImage="../img/parallax-bg-3.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">Terms of Services</div>
                </Parallax>
                <div className="p-5 body-lt">
                    <h2 className="kurb-med">Terms</h2>
                    <p className="pt-4">
                        SpeNeeds seeks for a fulfilling, rich community experience for all. Therefore, any breaches against
                        our faciltaing terms will not be tolerated. We ask of our community members to abide these rules:
                    </p>
                    <ol className="pt-2">
                        <li className="p-2">Use resources on the website appropriately</li>
                        <li className="p-2">Sign Up with approrpiate usernames and names</li>
                        <li className="p-2">Do not harass organizations or other members</li>
                        <li className="p-2">Do not show up to events to harass community members</li>
                    </ol>
                    <p> SpeNeeds is not liable for any misconducts of our users. </p>

                    <h2 className="pt-5 kurb-med">Termination</h2>
                    <p className="pt-4">
                        Failure to follow SpeNeed guidelines and terms will result in immediate termination or suspension from SpeNeeds,
                        with or without prior notice. SpeNeeds has the right to terminate your account and to contact any participants who
                        may be potentially involved. We are not accountable for any losses or any further issues regarding behavior that
                        violates our guidelines.
                    </p>
                    <h2 className="pt-5 kurb-med">Thank you</h2>
                    <p>
                        Thanks for following our guidelines. We hope to have everyone following our simple guidelines to provide the greatest
                        quality of experience for the community! :)
                    </p>
                </div>
            </section>
        );
    }
}